import { useLocation, Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  const defaultItems: BreadcrumbItem[] = [
    { name: '首页', href: '/' },
    ...pathParts.map((part, index) => {
      const href = '/' + pathParts.slice(0, index + 1).join('/');
      const nameMap: Record<string, string> = {
        category: '分类',
        comic: '漫画详情',
        about: '关于我们',
        all: '全部',
        romance: '恋爱',
        fantasy: '奇幻',
        action: '动作',
        comedy: '搞笑',
        thriller: '悬疑',
        drama: '剧情',
        daily: '日常',
        historical: '古风',
        horror: '恐怖',
      };
      return { name: nameMap[part] || part, href };
    }),
  ];

  const breadcrumbItems = items || defaultItems;

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.href ? `${window.location.origin}${__BASE_PATH__}${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-500 py-3 overflow-x-auto whitespace-nowrap">
        {breadcrumbItems.map((item, index) => (
          <span key={index} className="flex items-center">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs mx-2 text-foreground-400"></i>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">{item.name}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}